import React, { useCallback, useMemo } from "react";
import { Link } from "react-router-dom";

import { ReactComponent as Bookmark } from '../../assets/book-mark.svg'
import { ReactComponent as RightArrow } from '../../assets/right-arrow-myWishlist.svg'

import { Brands } from '../../utils/Brands'
import SendGTAGEvent from "../../utils/sendGTAGEvent";

import { SeparateLineBottom } from "../../utils/style"
import { Container, LeftContentWishlist, RightContentWishlist } from "./styles";

interface IMyWishlistItemProps {
    name: string;
    products: {
        price: number
    }[];
    environment: string;
    linkId: string;
    createdAt: string;
    linkName?: string;
    code?: string;
}


const MyWishlistItem: React.FC<IMyWishlistItemProps> = ({ name, products, environment, linkId, createdAt, linkName, code }) => {

    const convertDate = useCallback((date: string) => {
        const formatdate = new Date(date),
            day = formatdate.getDate().toString(),
            formattedDay = (day.length === 1) ? '0' + day : day,
            month = (formatdate.getMonth() + 1).toString(),
            formattedmonth = (month.length === 1) ? '0' + month : month,
            year = formatdate.getFullYear();

        return formattedDay + "/" + formattedmonth + "/" + year;
    }, [])

    const creationDateWishlist = useMemo(() => convertDate(createdAt), [convertDate, createdAt])

    const realWishlistBrandMemo = useMemo(() => (
        Brands.find(brand => brand.vtexName === environment)?.name
    ), [environment])


    const onCheckListValue = useCallback((amount: number) => {
        if (amount >= 10) {
            return amount
        } else {
            return `0${amount}`
        }
    }, [])

    const ContentlinkByWishlists = useMemo(() => (
        <React.Fragment>
            <LeftContentWishlist>
                <Bookmark />
                <div>
                    <p>{name}</p>
                    <p>{realWishlistBrandMemo}</p>
                </div>
            </LeftContentWishlist><RightContentWishlist>
                <div>
                    <small>{onCheckListValue(products.length)} Produtos</small>
                    <strong>{creationDateWishlist}</strong>
                </div>
                <RightArrow />
            </RightContentWishlist>
        </React.Fragment>
    ), [creationDateWishlist, name, onCheckListValue, products.length, realWishlistBrandMemo])

    return (
        <Container onClick={() => {
            SendGTAGEvent(
                'click_lojinha',
                'Lojinha',
                'Clicou para exibir infomações de uma lojinha',
                environment
            )
        }}>
            {!linkName ?
                <Link to={`/my-wishlists/${environment}/${linkId}`}>
                    {ContentlinkByWishlists}
                </Link>
                :
                <Link to={`/my-wishlists/${environment}/${linkName}/${code}/${linkId}`}>
                    {ContentlinkByWishlists}
                </Link>
            }
            <SeparateLineBottom />
        </Container>
    )
}

export default MyWishlistItem
